import dayjs from "dayjs";
import { PdfHeader, UiWarningRating } from "../../components";
import { formatPhoneNumber } from "../../utils/appUtils";

const ComplaintReport = ({
    activeTab,
    data,
    fromDate,
    toDate,
    complaintStatus,
    selectedMonth,
    selectedMonthString
}) => {
    const complaintData = data?.complaintsData;
    const lawyerInformation = data?.lawyerResponse;
    return (
        <div className="complaint-report">
            <div className="report-container">
                <PdfHeader pdfName={activeTab === "Complaints By Advocate" ? "Complaints By Advocate Report" : "Complaints Raised Advocate Report"} />
                <div style={{ padding: "10px" }}>
                    <div className="lawyer-information">
                        <div className="flexible" style={{ borderBottom: "1px solid rgba(177, 174, 174, 1)" }}>
                            <div>
                                {
                                    fromDate && toDate && <div>
                                        <p className="lawyerReport-heading">Date</p>
                                        <div>
                                            {
                                                fromDate && toDate ? `${dayjs(fromDate).format("DD-MM-YYYY")}-${dayjs(toDate).format("DD-MM-YYYY")}` : "Nil"
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    selectedMonth && <div>
                                        <p className="lawyerReport-heading">Month</p>
                                        <div>
                                            {dayjs(selectedMonth).format("MMMM YYYY")}
                                        </div>
                                    </div>
                                }
                            </div>
                            <div>
                                <h3 className="waring-content">Total Warning</h3>
                                <p className="waring-content" style={{ textAlign: "right" }}>{lawyerInformation?.totalWarningCount || "Nil"}</p>
                            </div>
                        </div>
                        <div className="flexible">
                            <div className="flexible" >
                                <img src={data?.lawyerProfile} alt="" style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }} />
                                <div>
                                    <h3 className="lawyerInfo-heading">{lawyerInformation?.salutation || "Nil"} {lawyerInformation?.firstName || "Nil"} {lawyerInformation?.middleName || "Nil"} {lawyerInformation?.lastName || "Nil"}</h3>
                                    <div style={{ padding: "5px 10px" }}>
                                        <UiWarningRating count={lawyerInformation?.warningCountAfterActive} />
                                    </div>
                                </div>
                            </div>
                            <div className="flexible">
                                <div>
                                    <p className="lawyerReport-heading">Bar Council ID</p>
                                    <h4 className="lawyerReport-info">{lawyerInformation?.barCouncilId || "Nil"}</h4>
                                </div>
                                <div>
                                    <p className="lawyerReport-heading">Lawyer ID</p>
                                    <h4 className="lawyerReport-info">{lawyerInformation?.lawyerNo || "Nil"}</h4>
                                </div>
                                <div>
                                    <p className="lawyerReport-heading">Mobile Number</p>
                                    <h4 className="lawyerReport-info">{formatPhoneNumber(lawyerInformation?.mobileNumber) || "Nil"}</h4>
                                </div>
                                <div>
                                    <p className="lawyerReport-heading">E-mail Address</p>
                                    <h4 className="lawyerReport-info">{lawyerInformation?.email || "Nil"}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <table className="report-table">
                    <thead>
                        <tr>
                            <th colSpan={1}>SNo</th>
                            <th colSpan={3}>Date</th>
                            <th colSpan={3}>Cons. Date</th>
                            <th colSpan={4}>Cons. ID</th>
                            <th colSpan={4}>Customer ID</th>
                            <th colSpan={6}>Complaint Description</th>
                            <th colSpan={5}>Recorded</th>
                            <th colSpan={5}>Complaint Status</th>
                            {
                                complaintStatus === "COMPLETED" && <th colSpan={5}>Action Taken</th>
                            }
                            {
                                complaintStatus === "COMPLETED" && <th colSpan={5}>Action Type</th>
                            }
                            {
                                complaintStatus === "COMPLETED" && <th colSpan={5}>Warned By</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {complaintData?.map((detail, index) => (
                            <tr key={detail?.id}>
                                <td colSpan={1}>{index + 1}</td>
                                <td colSpan={3}>{detail?.complaintDate ? dayjs(detail?.complaintDate).format("DD-MM-YYYY") : "Nil"}</td>
                                <td colSpan={3}>{detail?.consultationDetails?.consultationDate ? dayjs(detail?.consultationDetails?.consultationDate).format("DD-MM-YYYY") : "Nil"}</td>
                                <td colSpan={4}>{detail?.consultationDetails?.consultationNo || "Nil"}</td>
                                <td colSpan={4}>{activeTab === "COMPLAINT_RAISED_CUSTOMER" ? (detail?.raisedByNo || "Nil") : activeTab === "COMPLAINT_RAISED_LAWYER" ? (detail?.againstByNo || "Nil") : "Nil"}</td>
                                <td colSpan={6}>{detail?.complaintDescription || "Nil"}</td>
                                <td colSpan={5}>{detail?.recorded ? <div className="success-status" >
                                    <p style={{ padding: 0, margin: 0 }}>Recorded</p>
                                </div> : <div className="danger-status" ><p style={{ padding: 0, margin: 0 }}>Not Recorded</p></div>}</td>
                                <td colSpan={5}>{detail?.complaintStatus && detail?.complaintStatus === "PENDING" ? <div className="pending-status"><p>Pending</p></div>
                                    : detail?.complaintStatus && detail?.complaintStatus === "COMPLETED" ? <div className="success-status"><p>Completed</p></div> : <div>Nil</div>}</td>
                                <td colSpan={5}>{complaintStatus === "COMPLETED" ? (detail?.actionItemRaisedBy || "Nil") : "Nil"}</td>
                                <td colSpan={5}>{complaintStatus === "COMPLETED" ? (detail?.complaintActionType || "Nil") : "Nil"}</td>
                                <td colSpan={5}>{complaintStatus === "COMPLETED" ? (detail?.warnedByName || "Nil") : "Nil"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>)
};
export default ComplaintReport